import { QesColors } from "@app/shared/qes-standards/colors";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { MultiMapExportAdequacyOutcome, MultiMapExportContentGroup, MultiMapExportContentOption } from "@app/projects/network-assessment/multi-map-export/interfaces";

/**
 * Design system tokens matching the adequacy palette in the WI 208920 design: green passes, yellow fails
 * servicing, amber fails access, red fails both.
 */
const PASSING_SWATCH = Object.freeze({ border: QesColors.Green700, fill: QesColors.Green100 });
const FAILING_SERVICING_SWATCH = Object.freeze({ border: QesColors.QesTertiaryYellow2, fill: QesColors.QesTertiaryYellow4 });
const FAILING_ACCESS_SWATCH = Object.freeze({ border: QesColors.Amber700, fill: QesColors.Amber100 });
const FAILING_BOTH_SWATCH = Object.freeze({ border: QesColors.Red700, fill: QesColors.Red100 });

export const ADEQUACY_OUTCOME_HELPER_TEXT = "Selected outcomes determine which county/specialty combinations are included in the output.";

export const ADEQUACY_PASSING_OPTION: MultiMapExportContentOption<MultiMapExportAdequacyOutcome> = Object.freeze({
  label: "Passing",
  swatchBorderColor: PASSING_SWATCH.border,
  swatchColor: PASSING_SWATCH.fill,
  swatchIcon: QesIcons.Square,
  value: MultiMapExportAdequacyOutcome.Passing,
});

/** The parent carries no swatch: it toggles the group, it is not an outcome of its own. */
export const ADEQUACY_FAILING_GROUP: MultiMapExportContentGroup<MultiMapExportAdequacyOutcome> = Object.freeze({
  key: "failing",
  label: "Failing",
  options: Object.freeze([
    {
      label: "Failing (Servicing Provider Requirement)",
      swatchBorderColor: FAILING_SERVICING_SWATCH.border,
      swatchColor: FAILING_SERVICING_SWATCH.fill,
      swatchIcon: QesIcons.Square,
      value: MultiMapExportAdequacyOutcome.FailingServicingRequirement,
    },
    {
      label: "Failing (Access Requirement)",
      swatchBorderColor: FAILING_ACCESS_SWATCH.border,
      swatchColor: FAILING_ACCESS_SWATCH.fill,
      swatchIcon: QesIcons.Square,
      value: MultiMapExportAdequacyOutcome.FailingAccessRequirement,
    },
    {
      label: "Failing (Both Requirements)",
      swatchBorderColor: FAILING_BOTH_SWATCH.border,
      swatchColor: FAILING_BOTH_SWATCH.fill,
      swatchIcon: QesIcons.Square,
      value: MultiMapExportAdequacyOutcome.FailingBothRequirements,
    },
  ]),
});

/** Canonical stored order, so state never depends on the order the user clicked. */
export const ADEQUACY_OUTCOME_ORDER: readonly MultiMapExportAdequacyOutcome[] = Object.freeze([
  ADEQUACY_PASSING_OPTION.value,
  ...ADEQUACY_FAILING_GROUP.options.map((option) => option.value),
]);
